import { Injectable } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AlertOptions, AlertType } from '../models/alert.model';

@Injectable({ providedIn: 'root' })
export class AlertService {
  constructor(
    private message: NzMessageService,
    private notification: NzNotificationService
  ) {}

  success(message: string, duration = 3000) {
    this.message.success(message, { nzDuration: duration });
  }

  info(message: string, duration = 3000) {
    this.message.info(message, { nzDuration: duration });
  }

  warning(message: string, duration = 4000) {
    this.message.warning(message, { nzDuration: duration });
  }

  error(message: string, duration = 5000) {
    this.message.error(message, { nzDuration: duration });
  }

  errorList(messages: string[], duration = 5000) {
    messages.forEach(msg => {
      this.error(msg, duration);
    });
  }

  notify(type: AlertType, options: AlertOptions) {
    this.notification[type](
      options.title ?? 'Aviso',
      options.message,
      { nzDuration: options.duration ?? 5000 }
    );
  }
}